<div class="toast-container">
  @for (toast of toasts(); track toast) {
    <app-toast [toast]="toast"></app-toast>
  }
</div>
<router-outlet />
